import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
//import BGImage from '../../../../Utilities/default.jpg'
import EventAbstractContainer from './EventAbstractContainer'
import EditFloatWindowAbstract from './EditFloatWindowAbstract'
import ImageEditWindow from '../../../FunctionArea/ImageEditWindow'
import ContextMenu from '../../../FunctionArea/ContextMenu'


const wStyles = theme => ({
    appBarSpacer: theme.mixins.toolbar,

    scrollContainer:{
        //backgroundImage: `url(${BGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundSize: "cover",
        position:"relative",
        width:"100%",
        overflow:"auto"
    },
});

// const imageObject = {
//     imageID:null,
//     order:null,
//     //url:"http://192.168.43.243:5000/api/fetchEventImage/2020-02-15T01:55:50.671Z-romantic_movie.jpg",
//     url:null,
//     transitionMethod:"none",
//     transitionTime:60,
//     file:null,
//     imageAdjust:{
//         contrast:100,
//         hue:0,
//         brightness:100,
//         saturate:100,
//         sepia:0,
//         invert:0,
//         blur:0,
//         opacity:100
//     }
// }

class EditAbstract extends Component {
    constructor(props) {
        super(props)
        this.state = {
            layoutHeightNotFull:'50vh',
            layoutHeightFull:800,
            mousePos:{
                x:0,
                y:0
            },
            refPos:{
                x:0,
                y:0
            },  
            EditFloatWindowPos:{
                x:0,
                y:0
            },
            needMousePos:false,
            containerExtending:{
                status:false,
                conID:0,
            },
            containerDragging:{
                status:false,
                conID:0
            },
            selectedImageID:null,
            showImageEditor:false,
            contextManu:{
                status:false,
                pos:null,
                conID:null,
                command:null,
                from:null,
            },
            editingField:0,
            eventAbstractDetail: {
                Event_Title:"專題標題",
                Event_SubTitle:"專題副標題",
                Event_Story:"專題介紹:請於此處編寫專題之簡介",
                Event_Images:[
                   
                ]
            }
        }
        this.openTempFile = React.createRef()
        this.scrollContainerLayout = React.createRef()
        
    }

    componentDidMount(){
        this.initialEventAbstract()
    }

    componentDidUpdate(preProps,preState){
        if(preProps.eventAbstract !== this.props.eventAbstract)
        {
            this.setState({
                eventAbstractDetail:this.props.eventAbstract
            })
        }
    }

    componentWillUnmount(){
        let msg = this.state.eventAbstractDetail
        this.props.getEventAbstract(msg)
    }

    initialEventAbstract=()=>{
        if(this.props.eventAbstract){
            this.setState({
                eventAbstractDetail:this.props.eventAbstract
            })
        }
    }


    onContainerExtending = (msg)=>{
        //console.log('ControllerUnitLayout onContainerExtending')
        let conIDToken = 0
        if(msg.containerExtending)
        {
            if(msg.conID === 0)
            {
                this.setState({
                    containerExtending:{
                        status:msg.containerExtending,
                        conID:msg.conID,
                    },
                    needMousePos:true,
                })
            }
            else
            {
                conIDToken = msg.conID
                this.setState({
                    containerExtending:{
                        status:msg.containerExtending,
                        conID:conIDToken,
                    },
                    needMousePos:true,
                })
            }
        }
        else
        {
            this.setState({
                containerExtending:{
                    status:false,
                    conID:conIDToken,
                },
                needMousePos:false,
                mousePos:{
                    x:0,
                    y:0
                },
                
            })
        }
    }

    onContainerDragging = (msg) => {
        //console.log('ControllerUnitLayout onContainerDragging')
        //console.log('conID : ',msg.conID, 'booling : ',msg.containerDragging)
        //console.log(msg.position)
        let conIDToken = 0
        if(msg.containerDragging)
        {
            if(msg.conID === 0 )
            {
                this.setState({
                    containerDragging:{
                        status:msg.containerDragging,
                        conID:msg.conID
                    },
                    needMousePos:true,
                })
            }
            else
            {
                //console.log('onContainerDragging true')
                this.setState({
                    containerDragging:{
                        status:msg.containerDragging,
                        conID:msg.conID
                    },
                    needMousePos:true,
                })
            }
        }
        else
        {
            let tempFullHeight = 0 
            let tempNotFullHeight = 0
            console.log(this.scrollContainerLayout.scrollHeight)
            
            if(this.scrollContainerLayout.scrollHeight > 800)
            {
                tempFullHeight = this.scrollContainerLayout.scrollHeight
                tempNotFullHeight = this.scrollContainerLayout.scrollHeight
            }
            else if( 800 >= this.scrollContainerLayout.scrollHeight && this.scrollContainerLayout.scrollHeight > 600)
            {
                tempFullHeight = 800
                tempNotFullHeight = this.scrollContainerLayout.scrollHeight
            }
            else if(600 >= this.scrollContainerLayout.scrollHeight)
            {
                tempFullHeight = 800
                tempNotFullHeight = 600
            }
            
            this.setState({
                layoutHeightNotFull:tempNotFullHeight,
                layoutHeightFull:tempFullHeight,
                EditFloatWindowPos:msg.position,
                containerDragging:{
                    status:false,
                    conID:conIDToken
                },
                needMousePos:false,
                mousePos:{
                    x:0,
                    y:0
                },
            })
        }
    }

    onMouseMove=(e)=>{
        console.log("ComponentLayot onMouseMove...")

        if(this.state.needMousePos)
        { 
            this.setState({
                mousePos:{
                    x:e.clientX,
                    y:e.clientY
                },
            })
        }
    }

    onClick=(e)=>{
        this.setState({
            contextManu:{
                status:false,
                pos:null,
                conID:null,
                command:null,
                from:null,
            },
        })
    }

    getAbstractTitle=(msg)=>{
        if(this.state.eventAbstractDetail.Event_Title !== msg)
        {
            this.setState({
                eventAbstractDetail:{
                    Event_Title:msg,
                    Event_SubTitle:this.state.eventAbstractDetail.Event_SubTitle,
                    Event_Story:this.state.eventAbstractDetail.Event_Story,
                    Event_Images:this.state.eventAbstractDetail.Event_Images
                }
            })
        }
    }

    getAbstractSubTitle=(msg)=>{
        if(this.state.eventAbstractDetail.Event_SubTitle !== msg)
        {
            this.setState({
                eventAbstractDetail:{
                    Event_Title:this.state.eventAbstractDetail.Event_Title,
                    Event_SubTitle:msg,
                    Event_Story:this.state.eventAbstractDetail.Event_Story,
                    Event_Images:this.state.eventAbstractDetail.Event_Images
                }
            })
        }
    }

    getAbstractStory=(msg)=>{
        if(this.state.eventAbstractDetail.Event_Story !== msg)
        {
            this.setState({
                eventAbstractDetail:{
                    Event_Title:this.state.eventAbstractDetail.Event_Title,
                    Event_SubTitle:this.state.eventAbstractDetail.Event_SubTitle,
                    Event_Story:msg,
                    Event_Images:this.state.eventAbstractDetail.Event_Images
                }
            })
        }
    }

    getImageFinalStage=(msg)=>{
        this.setState({
            eventAbstractDetail:{
                Event_Title:this.state.eventAbstractDetail.Event_Title,
                Event_SubTitle:this.state.eventAbstractDetail.Event_SubTitle,
                Event_Story:this.state.eventAbstractDetail.Event_Story,
                Event_Images:msg
            }
        })
    }

    getImage=(msg)=>{
        console.log("EditFloatWindowAbstract getImage...")
        console.log(msg)
        let tempImageArray = []
        if(this.state.selectedImageID)
        {
            this.state.eventAbstractDetail.Event_Images.forEach(image=>{
                if(this.state.selectedImageID === image.imageID)
                {
                    let tempObj = {
                        imageID:image.imageID,
                        order:image.order,
                        transitionMethod:image.transitionMethod,
                        transitionTime:image.transitionTime,
                        imageUrl:msg.imageUrl,
                        file:image.file,
                        imageAdjust:msg.imageAdjust,
                        originalImageSize:msg.originalImageSize,
                        dynamicImageSize:msg.dynamicImageSize,
                    }
                    tempImageArray.push(tempObj)
                }
                else
                {
                    tempImageArray.push(image)
                }
            })
        }
        else
        {  
            if(this.state.eventAbstractDetail.Event_Images)
            {
                if(this.state.eventAbstractDetail.Event_Images.length === 0)
                {
                    let tempObj = {
                        imageID:1,
                        order:1,
                        transitionMethod:"none",
                        transitionTime:60,
                        imageUrl:msg.imageUrl,
                        file:null,
                        imageAdjust:msg.imageAdjust,
                        originalImageSize:msg.originalImageSize,
                        dynamicImageSize:msg.dynamicImageSize,
                    }
                    tempImageArray.push(tempObj)
                }
                else
                {
                    let newID = Math.max.apply(Math, this.state.eventAbstractDetail.Event_Images.map(image=>{
                        return image.imageID
                    })) + 1
                    let newOrder = Math.max.apply(Math, this.state.eventAbstractDetail.Event_Images.map(image=>{
                        return image.order
                    })) + 1

                    tempImageArray = this.state.eventAbstractDetail.Event_Images

                    let tempObj = {
                        imageID:newID,
                        order:newOrder,
                        transitionMethod:"none",
                        transitionTime:60,
                        imageUrl:msg.imageUrl,
                        file:null,
                        imageAdjust:msg.imageAdjust,
                        originalImageSize:msg.originalImageSize,
                        dynamicImageSize:msg.dynamicImageSize,
                    }
                    tempImageArray.push(tempObj)
                }

            }
            else
            {
                let tempObj = {
                    imageID:1,
                    order:1,
                    transitionMethod:"none",
                    transitionTime:60,
                    imageUrl:msg.imageUrl,
                    file:null,
                    imageAdjust:msg.imageAdjust,
                    originalImageSize:msg.originalImageSize,
                    dynamicImageSize:msg.dynamicImageSize,
                }
                tempImageArray.push(tempObj)
            }     
        }
        
        this.setState({
            showImageEditor:false
        })
        this.getImageFinalStage(tempImageArray)
    }

    loadImageToEditor=(id)=>{
        let output={}
        if(this.state.eventAbstractDetail.Event_Images)
        {
            this.state.eventAbstractDetail.Event_Images.forEach(image=>{
                if(image.imageID === id)
                {
                    output = image
                }
            })
        }
        return output
    }

    abstractFieldOnClick=(msg)=>{
        if(this.state.editingField !== msg)
        {
            this.setState({
                editingField:msg
            })
        }
    }

    openImageEditor=(msg)=>{
        if(msg)
        {
            if(this.state.selectedImageID !== msg)
            {
                this.setState({
                    selectedImageID:msg,
                    showImageEditor:true
                })
            }
        }
        else
        { 
            this.setState({
                selectedImageID:null,
                showImageEditor:true
            })
        }
    }

    openContextManu=(msg)=>{
        this.setState({
            contextManu:{
                status:true,
                pos:msg.pos,
                conID:msg.ID,
                command:null,
                from:"abstractBackgroundImage",
            },
        })
    }

    getCommand=(msg)=>{
        if(msg==="delete")
        {
            if(this.state.contextManu.conID)
            {
                let tempImageArray = this.state.eventAbstractDetail.Event_Images.filter(image=>{
                    if(this.state.contextManu.conID === image.imageID)
                    {
                        return false         
                    }
                    else
                    {
                        return true
                    }
                })
                this.setState({
                    eventAbstractDetail:{
                        Event_Title:this.state.eventAbstractDetail.Event_Title,
                        Event_SubTitle:this.state.eventAbstractDetail.Event_SubTitle,
                        Event_Story:this.state.eventAbstractDetail.Event_Story,
                        Event_Images:tempImageArray
                    },
                    contextManu:{
                        status:false,
                        pos:null,
                        conID:null,
                        command:null,
                        from:null,
                    }
                })
            }
        }
        else if(msg==="cancel")
        {
            this.setState({
                contextManu:{
                    status:false,
                    pos:null,
                    conID:null,
                    command:null,
                    from:null,
                },
            })
        }
    }

    render(){
        const {classes} = this.props;

        let containerNotFullScreen = {
            height:this.state.layoutHeightNotFull
        }

        let containerFullScreen = {
            //height:this.state.layoutHeightFull,
            top:"165px"
        }

        let bufferAreaNotFullScreen = {
            height:"10px"
        }

        let bufferAreaFullScreen = {
            height:"200px"
        }

        return (

            <div className={classes.scrollContainer} style={this.props.fullScreen? containerFullScreen:containerNotFullScreen} ref={(scrollContainerLayout)=>{this.scrollContainerLayout=scrollContainerLayout}}  mousePos={this.state.mousePos} onMouseMove={this.onMouseMove} onClick={this.onClick}> 
                <div style={this.props.fullScreen? bufferAreaFullScreen:bufferAreaNotFullScreen}/>                  
                <EventAbstractContainer eventDetail={this.state.eventAbstractDetail} abstractFieldOnClick={this.abstractFieldOnClick}/>
                {this.state.editingField === 0 ? null:<EditFloatWindowAbstract conID={0} mousePos={this.state.mousePos} containerExtending={this.onContainerExtending} containerDragging={this.onContainerDragging} editingField={this.state.editingField} eventDetail={this.state.eventAbstractDetail} openImageEditor={this.openImageEditor} openContextManu={this.openContextManu} getAbstractTitle={this.getAbstractTitle} getAbstractSubTitle={this.getAbstractSubTitle} getAbstractStory={this.getAbstractStory} getImage={this.getImage} />}
                <ImageEditWindow showImageEditor={this.state.showImageEditor} loadImage={this.loadImageToEditor(this.state.selectedImageID)} loadImageContainerSize={null} getImage={this.getImage} closeImageEditor={()=>this.setState({showImageEditor:false})} editImageSize={false}></ImageEditWindow>
                {this.state.contextManu.status? <ContextMenu pos={this.state.contextManu.pos} prevConID={this.state.contextManu.conID} prevCommand={this.state.contextManu.command} invokeFrom={this.state.contextManu.from} getCommand={this.getCommand}/>:null}
            </div>
        )  
    }
}

export default withStyles(wStyles)(EditAbstract)